import { ref } from 'vue'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { defineStore } from 'pinia'

import { useOrderService } from '~/core/services'
import type { Nullable } from '~/core/types'
import type { Cart, Recap } from '~/core/types/order'
import { PaymentStatus, ShoppingCartStep } from '~/core/types/order'

export const useCartStore = defineStore('cart', () => {
  const { getCart } = useOrderService()
  const queryClient = useQueryClient()

  const recap = ref<Nullable<Recap>>(null)
  const paymentStatus = ref<PaymentStatus>(PaymentStatus.IDLE)
  const paymentError = ref<string[]>([])
  // const cart = ref<Nullable<Cart>>(null)
  const activeCartStep = ref<ShoppingCartStep>(ShoppingCartStep.BASKET)

  const { data, isFetching, refetch: refetchCart } = useQuery({
    queryKey: ['cart'],
    queryFn: getCart,
    staleTime: 2 * 60 * 60 * 1000, // 2H
  })

  const cart = computed(() => data.value?.data ?? null)

  // const { mutate } = useMutation<Nullable<FetchResult<Cart>>>({
  //   mutationFn: getCart,
  //   onSuccess: (res) => {
  //     cart.value = res?.data ?? null
  //   },
  // })

  function reset() {
    recap.value = null
    paymentStatus.value = PaymentStatus.IDLE
    paymentError.value = []
    activeCartStep.value = ShoppingCartStep.BASKET
    updateCart(null)
  }

  function updateCart(c: Nullable<Partial<Cart>>) {
    if (!c) {
      queryClient.setQueryData(['cart'], null)
      return
    }
    queryClient.setQueryData(['cart'], { ...data.value, data: { ...data.value?.data, ...c } })
  }

  return {
    cart,
    recap,
    paymentStatus,
    paymentError,
    reset,
    refetchCart,
    isFetching,
    updateCart,
    activeCartStep,
  }
})
